import React, { FC } from "react";
import { TransferMetricKey, TransferTabKey } from "./statisticsConfig";
import TransferOverallTab from "./Tabs/TransferOverallTab";
import TransferCurrencyTab from "./Tabs/TransferCurrencyTab";

export interface IDailyDeal {
    date: number;
    count: number;
    volume: number;
    profit: number;
}

interface TransferSectionProps {
    stats: any;
    dailyDeals: IDailyDeal[] | null;
    yearlyDeals: IDailyDeal[] | null;

    linkTo: string;
    colorConfig: { textColor: string; color: string };

    transferTab: TransferTabKey;
    setTransferTab: (v: TransferTabKey) => void;

    transferMetric: TransferMetricKey;
    setTransferMetric: (v: TransferMetricKey) => void;

    overallDateFrom: string;
    overallDateTo: string;
    setOverallDateFrom: (v: string) => void;
    setOverallDateTo: (v: string) => void;

    currencyDateFrom: string;
    currencyDateTo: string;
    setCurrencyDateFrom: (v: string) => void;
    setCurrencyDateTo: (v: string) => void;

    selectedCurrency: string;
    setSelectedCurrency: (v: string) => void;

    onResetOverall: () => void;
    onResetCurrency: () => void;

    dailyDealsPeriod: "month" | "year";
    setDailyDealsPeriod: (v: "month" | "year") => void;

    dailyDealsYear: number;
    setDailyDealsYear: (v: number) => void;

    dailyDealsMonth: number;
    setDailyDealsMonth: (v: number) => void;

    availableYears: number[];
}

const TransferSection: FC<TransferSectionProps> = props => {
    const {
        stats,
        dailyDeals,
        yearlyDeals,
        linkTo,
        colorConfig,
        transferTab,
        setTransferTab,
        transferMetric,
        setTransferMetric,
        overallDateFrom,
        overallDateTo,
        setOverallDateFrom,
        setOverallDateTo,
        currencyDateFrom,
        currencyDateTo,
        setCurrencyDateFrom,
        setCurrencyDateTo,
        selectedCurrency,
        setSelectedCurrency,
        onResetOverall,
        onResetCurrency,
        dailyDealsPeriod,
        setDailyDealsPeriod,
        dailyDealsYear,
        setDailyDealsYear,
        dailyDealsMonth,
        setDailyDealsMonth,
        availableYears
    } = props;

    return (
        <>
            <div className="statistics-items__transfer-tabs">
                <button
                    type="button"
                    className={
                        transferTab === "OVERALL"
                            ? "statistics-items__transfer-tab statistics-items__transfer-tab--active"
                            : "statistics-items__transfer-tab"
                    }
                    onClick={() => setTransferTab("OVERALL")}
                >
                    Общая статистика
                </button>

                <button
                    type="button"
                    className={
                        transferTab === "CURRENCY"
                            ? "statistics-items__transfer-tab statistics-items__transfer-tab--active"
                            : "statistics-items__transfer-tab"
                    }
                    onClick={() => setTransferTab("CURRENCY")}
                >
                    По валюте
                </button>
            </div>

            {transferTab === "OVERALL" && (
                <TransferOverallTab
                    stats={stats}
                    dailyDeals={dailyDeals}
                    yearlyDeals={yearlyDeals}
                    linkTo={linkTo}
                    colorConfig={colorConfig}
                    transferMetric={transferMetric}
                    setTransferMetric={setTransferMetric}
                    overallDateFrom={overallDateFrom}
                    overallDateTo={overallDateTo}
                    setOverallDateFrom={setOverallDateFrom}
                    setOverallDateTo={setOverallDateTo}
                    onReset={onResetOverall}

                    chartPeriod={dailyDealsPeriod}
                    setChartPeriod={setDailyDealsPeriod}
                    chartYear={dailyDealsYear}
                    setChartYear={setDailyDealsYear}
                    chartMonth={dailyDealsMonth}
                    setChartMonth={setDailyDealsMonth}

                    availableYears={availableYears}
                />
            )}

            {transferTab === "CURRENCY" && (
                <TransferCurrencyTab
                    stats={stats}
                    linkTo={linkTo}
                    selectedCurrency={selectedCurrency}
                    setSelectedCurrency={setSelectedCurrency}
                    currencyDateFrom={currencyDateFrom}
                    currencyDateTo={currencyDateTo}
                    setCurrencyDateFrom={setCurrencyDateFrom}
                    setCurrencyDateTo={setCurrencyDateTo}
                    onReset={onResetCurrency}
                />
            )}
        </>
    );
};

export default TransferSection;